import fetchServer from "../fetchServer";


export default async function createVirtualAccount(data) {
  var result = {return: 0,msg: 'Failed creating account',data: []}

  await fetchServer({method: "POST",url: `/api/payment/v1/virtualAccount`,data})
  .then((res) => {
    if(res) {
      if(res.status === 200) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res.error) result['msg'] = res.error?.message;
    } 
  })
  .catch((err) => {
    console.log(err.message,err);
    if(err.message === 'Network Error!') {
      result['msg'] = 'Network Error!';
      result['error'] = 'Please check your connection.';
    }
  })

  return result;
}